/**
 * Created by Carsten Bühler
 * User: CBuehler on 09.11.2015
 * Copyright: xdot GmbH 2015
 */


import { ApiUtil, AppContext } from 'plugin/liferay-widgets-react-web';
import { Client, FileUploader } from 'external/lwr-client';

//const uploadService = (m, o) => Client.invoke('/base.uploadapi/' + m, o);
const uploadServiceWithContext = (m, o, c) => Client.invokeWithContext('/base.uploadapi/' + m, o, c);
const uploader = new FileUploader(Client, '/base.uploadapi/upload-temp.3');

const api = {

    uploadTemp(file, { onProgress }) {
        const options = {};
        const serviceContext = {
            scopeGroupId: AppContext.getScopeGroupId()
        };

        const params = {
            serviceContext: JSON.stringify(serviceContext),
            fileName: file.name
        };

        const opts = {
            options, params, onProgress
        };
        return uploader.upload(file, opts);
    },

    deleteTemp(query) {
        return uploadServiceWithContext('delete-temp.2', {
            fileName: query.tmpFileName
        }, {});
    }

};

ApiUtil.namedApi('UploadWebApi', api);

export default api;



// WEBPACK FOOTER //
// ./js/webapi/UploadWebApi.js